import { render, staticRenderFns } from "./ReplicantiGainText.vue?vue&type=template&id=b95a2998&scoped=true"
import script from "./ReplicantiGainText.vue?vue&type=script&lang=js"
export * from "./ReplicantiGainText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95a2998",
  null
  
)

export default component.exports